var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "header",
    { staticClass: "tab-header-container" },
    [
      _c("div", { staticClass: "header-title-container" }, [
        _c("p", {
          staticClass: "header-title",
          domProps: { innerHTML: _vm._s(_vm.title) },
        }),
      ]),
      _c("v-spacer"),
      _c("LfActionsBarComponent", {
        staticClass: "action-buttons",
        attrs: { buttons: _vm.buttons, showKebabMenu: _vm.showKebabMenu },
        on: { "execute-action": _vm.executeAction },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }